<template>
  <div class="container login">
    <div class="mb-4">
      <div v-if="showUpdatePasswordForm">
        <h4>Actualizar Contraseña</h4>
          <div class="form-group">
            <label class="text-normal text-dark">Nueva contraseña</label>
            <password
              v-model="updatePasswordCredentials.newPassword"
              :strength-meter-only="false"
              :toggle="true"
              :default-class="'form-control'"
            />
          </div>
          <div class="form-group">
            <label class="text-normal text-dark">Confirma la nueva contraseña</label>
            <password
              v-model="updatePasswordCredentials.confirmNewPassword"
              :strength-meter-only="false"
              :toggle="true"
              :default-class="'form-control'"
            />
          </div>
          <div
            class="alert alert-danger"
            role="alert"
            v-if="showPasswordDoNotMatch"
          >Las contraseñas no coinciden</div>
          <div class="form-group">
            <div class="peers ai-c jc-sb fxw-nw">
              <div class="peer"></div>
              <div class="peer">
                <!-- <recaptcha
                  :sitekey="sitekey"
                  :successCallback="successRecaptcha"
                  :errorCallback="errorRecaptcha"
                  :action="'updatepassword'"
                  class="btn btn-orange"
                  id="updatepassbtn"
                  type="button"
                  ref="updatepassbtn"
                >
                  <template v-slot:default="slotProps">
                    <span v-if="slotProps.executing">
                      <font-awesome-icon :icon="['fal', 'spinner']" spin />&nbsp;Actualizando
                    </span>
                    <span v-else key="ingresar">Actualizar</span>
                  </template>
                </recaptcha> -->
                <button type="reset" @click="updatePassword">
                  Actualizar
                </button>
              </div>
            </div>
          </div>
      </div>
      <div v-else>
        <h4 class="text-center">Iniciar Sesión</h4>
          <div class="form-group">
            <label class="text-normal text-dark">Email</label>
            <input
              type="email"
              class="form-control"
              placeholder="correo@dominio.com"
              v-model="credentials.email"
            />
          </div>
          <div class="form-group">
            <label class="text-normal text-dark">Contraseña</label>
            <input
              type="password"
              class="form-control"
              placeholder="************"
              v-model="credentials.password"
            />
          </div>
          <div class="form-group text-center">
            <div class="peers ai-c jc-sb fxw-nw">
              <div class="peer" style="margin-right: auto; margin-left: auto;">
                <!-- <recaptcha
                  :sitekey="sitekey"
                  :successCallback="successRecaptcha"
                  :errorCallback="errorRecaptcha"
                  :action="'signin'"
                  class="btn btn-orange"
                  id="loginbtn"
                  type="button"
                  ref="loginbtn"
                >
                  <template v-slot:default="slotProps">
                    <span v-if="slotProps.executing">
                      <font-awesome-icon :icon="['fal', 'spinner']" spin />&nbsp;Autenticando
                    </span>
                    <span v-else key="ingresar">Ingresar</span>
                  </template>
                </recaptcha> -->
                <button @click="login">Iniciar</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Password from 'vue-password-strength-meter'
// import Recaptcha from '@/components/general/Recaptcha.vue'
import config from '@/config'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    // Recaptcha,
    Password
  },
  data () {
    return {
      credentials: {
        email: '',
        password: ''
      },
      updatePasswordCredentials: {
        newPassword: '',
        confirmNewPassword: ''
      },
      isLoading: false,
      showUpdatePasswordForm: false,
      showPasswordDoNotMatch: false
    }
  },
  computed: {
    sitekey () {
      return this.$_.get(config, 'reCAPTCHA.siteKey', '')
    }
  },
  watch: {
    updatePasswordCredentials: {
      deep: true,
      handler () {
        this.comparePasswords()
      }
    }
  },
  methods: {
    ...mapActions({
      signIn: 'signIn',
      updatePasswordOnSignIn: 'updatePasswordOnSignIn'
    }),
    comparePasswords () {
      if (this.updatePasswordCredentials.newPassword === this.updatePasswordCredentials.confirmNewPassword) {
        this.showPasswordDoNotMatch = false
      } else {
        this.showPasswordDoNotMatch = true
      }
    },
    async successRecaptcha () {
      this.isLoading = true
      if (this.showUpdatePasswordForm) {
        await this.updatePassword()
      } else {
        await this.login()
      }
    },
    async errorRecaptcha () {
      this.isLoading = false
      this.showError('Captcha no valido intentalo de nuevo.')
    },
    async login () {
      try {
        const login = await this.signIn(this.credentials)
        console.log('Login login', login, login.authenticated && login.forceResetPassword)
        if (login.authenticated && login.forceResetPassword) {
          this.showUpdatePasswordForm = true
        } else if (login.authenticated) {
          this.$router.push({ name: 'dashboard' })
        } else {
          this.showError('Usuario o contraseña incorretos, intentalo de nuevo.')
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.showError(error.message)
      }
    },
    async toFormDataXd (obj) {
      return new Promise((resolve, reject) => {
        console.log('toFormDataXd **', obj)
        const formData = new FormData()
        for (const key in obj) {
          // console.log('DENTRO DE EL LLOOP', key)
          formData.append(key)
        }
        console.log('formDataCXD', formData)
        resolve(formData)
      })
    },
    async updatePassword () {
      try {
        const emptyNewPassword = this.$_.isEmpty(this.updatePasswordCredentials.newPassword)
        const emptyConfirmPassword = this.$_.isEmpty(this.updatePasswordCredentials.confirmNewPassword)
        if (emptyNewPassword || emptyConfirmPassword) {
          this.isLoading = false
          this.showError('Debes llenar todos los campos.')
          return
        }
        this.updatePasswordCredentials.email = this.credentials.email
        const response = await this.updatePasswordOnSignIn(this.updatePasswordCredentials)
        if (response.updated) {
          this.$router.push({ name: 'dashboard' })
        }
      } catch (error) {
        this.isLoading = false
        this.showError(error.message)
      }
    }
  }
}
</script>
